import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import { useNavigate } from "react-router-dom";
import LoginBannerhi from "../../../assets/images/HindiBanner.png";
import LoginBannermr from "../../../assets/images/MarathiBanner.png";
import LoginBannerkn from "../../../assets/images/KannadaBanner.png";
import LoginBannerte from "../../../assets/images/TeluguBanner.png";
import LoginBannerta from "../../../assets/images/tamilBanner.png";
import LoginBannerbn from "../../../assets/images/HindiBanner.png";
import TextBannerHi from "../../../assets/images/textBannerHi.jpg";
import TextBannerMr from "../../../assets/images/textBannerMr.jpg";
import textBannerEn from "../../../assets/images/textBannerEn.jpg";
import TextBannerTe from "../../../assets/images/textBannerTe.jpg";
import greenRight from "../../../assets/images/green_right.png";
import Close from "../../../assets/images/cross.png";
import { useForm } from "react-hook-form";
import { Loader } from "../../loader";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { claimStatus, rewardMoney } from "../../auth/redux/store";
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import CustomModal from "../../modal";
import FarmingDetails from "../../../assets/images/farmingDetails.jpg";
import productShare from "../../../assets/images/productShare.jpg";

export const Congratulations = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const [loading, setLoading] = useState(false);
    const [totalAcres, setTotalAcres] = useState('');
    const [profileUpdateModal, setprofileUpdateModal] = useState(false);
    const [profileUpdateSuccessModal, setprofileUpdateSuccessModal] = useState(false);
    const [rewardsModal, setRewardsModal] = useState(false);
    const [sharesuccessModal, setsharesuccessModal] = useState(false);
    const [selectedCrop, setSelectedCrop] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [resObj, setResObj] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        lastName: "",
        mobileNumber: "",
        village: "",
        districtName: "",
        pincode: "",
        crop: "",
        acers: ""
    });

    dispatch(claimStatus(false));
    dispatch(rewardMoney(0));
    const productName = sessionStorage.getItem('storedProductName');
    const queryParams = new URLSearchParams(window.location.search);
    const mobileNumber = atob(queryParams.get('m'));
    const cid = atob(queryParams.get('c'));
    const querystate = queryParams.get('state');
    const queryStepOneOk = queryParams.get('StepOneOk') === 'true';
    const queryprofileUpdate = queryParams.get('profileUpdate') === 'true';
    const queryshareProductInfo = queryParams.get('shareProductInfo') === 'true';
    const [stepOneClear, setStepOneClear] = useState(queryprofileUpdate);
    const [stepTwoClear, setStepTwoClear] = useState(queryshareProductInfo);
    const [errorMessage, setErrorMessage] = useState("");
    useEffect(() => {
        if (queryStepOneOk) {
            setprofileUpdateModal(true);
        }
    }, [queryStepOneOk]);

    // debugger; 
    if (!sessionStorage.getItem('mbn') || !sessionStorage.getItem('cid')) {
        if (mobileNumber && cid) {
            sessionStorage.setItem('mobileNumber', mobileNumber);
            sessionStorage.setItem('cid', cid);
        } else {
            sessionStorage.setItem('mobileNumber', '');
            sessionStorage.setItem('cid', '');
        }
    }

    const storedMblNumber = sessionStorage.getItem("mbn");

    let bannerImageSrc;
    if (lang === 'hi') {
        bannerImageSrc = LoginBannerhi;
    } else if (lang === 'mr') {
        bannerImageSrc = LoginBannermr;
    }
    else if (lang === 'kn') {
        bannerImageSrc = LoginBannerkn;
    } else if (lang === 'te') {
        bannerImageSrc = LoginBannerte;
    } else if (lang === 'or') {
        bannerImageSrc = LoginBannerhi;
    } else if (lang === 'bn') {
        bannerImageSrc = LoginBannerbn;
    } else if (lang === 'ta') {
        bannerImageSrc = LoginBannerta;
    }
    else {
        bannerImageSrc = LoginBannerhi;
    }


    let textBannerImageSrc;
    if (lang === 'hi') {
        textBannerImageSrc = TextBannerHi;
    } else if (lang === 'mr') {
        textBannerImageSrc = TextBannerMr;
    }
    else if (lang === 'kn') {
        textBannerImageSrc = TextBannerHi;
    } else if (lang === 'te') {
        textBannerImageSrc = TextBannerTe;
    } else if (lang === 'or') {
        textBannerImageSrc = TextBannerHi;
    } else if (lang === 'bn') {
        textBannerImageSrc = TextBannerHi;
    } else if (lang === 'ta') {
        textBannerImageSrc = TextBannerHi;
    } else if (lang === 'en') {
        textBannerImageSrc = textBannerEn;
    }
    else {
        textBannerImageSrc = TextBannerHi;
    }

    const [formErrors, setFormErrors] = useState({
        name: false,
        cropName: false
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
        clearErrors,
    } = useForm();

    const handleCloseModal = () => {
        setSelectedCrop("");
        setTotalAcres("");
        setprofileUpdateModal(false);
        setprofileUpdateSuccessModal(false);
    };

    const handleStepOneClear = (e) => {
        e.preventDefault();
        setprofileUpdateSuccessModal(false);
        const getprofileUpdate = sessionStorage.getItem("resprofileUpdate");
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        if (params.get('profileUpdate') === 'false') {
            params.set('profileUpdate', getprofileUpdate);
            window.history.replaceState({}, '', `${url.pathname}?${params}`);
        }
        setStepOneClear(getprofileUpdate);
        window.location.href = `${process.env.REACT_APP_API_URL_PRODUCT}${t("language")}?mobileNumber=${btoa(storedMblNumber)}`;
    };
    const handleCropChange = (event) => {
        // debugger;
        const value = event.target.id
        setSelectedCrop(value);
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            cropName: false,
        }));
    };

    const handletotalAcresInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "totalAcres") {
            // Allow only digits and one decimal point
            let sanitizedValue = value.replace(/[^0-9.]/g, '');

            // Prevent multiple decimals
            const parts = sanitizedValue.split('.');
            if (parts.length > 2) {
                return;
            }

            // Limit digits before and after decimal
            let validValue = parts[0].slice(0, 3); // max 3 digits before decimal

            if (parts[1] !== undefined) {
                validValue += '.' + parts[1].slice(0, 2); // max 2 digits after decimal
            }

            // Disallow value if it's just 0 without decimal
            if (validValue === '0') {
                return;
            }

            e.target.value = validValue;
            setTotalAcres(validValue);

            if (validValue.length > 0) {
                setFormErrors((prevErrors) => ({
                    ...prevErrors,
                    totalAcres: false,
                }));
            }

            clearErrors(validValue); // Pass current value
        }
    };

    //niharika  
    const getDetilsobj = {
        mobileNumber: storedMblNumber
    }
    useEffect(() => {
        const fetchFarmerDetails = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL_GLOBAL}getRinskorFarmerDetailes`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(getDetilsobj),
                });
                // debugger;
                const data = await response.json();
                const repsData = data.response;
                //  console.log(repsData.districtList[0].name);
                if (repsData) {
                    setFormData({
                        name: repsData.firstName,
                        lastName: repsData.lastName,
                        mobileNumber: repsData.mobileNumber,
                        districtName: repsData.districtList[0].name,
                        village: repsData.villageName,
                        pincode: repsData.pincode,
                        crop: repsData.crop,
                        acers: repsData.riceCropAcres,
                    });

                    if (!repsData.profileUpdate) {
                        return setprofileUpdateModal(true)
                    } else if (!repsData.shareProductInfo) {
                        return setprofileUpdateSuccessModal(true)
                    } else if (repsData.shareProductInfo) {
                        setsharesuccessModal(true);
                    }
                    else {
                        setprofileUpdateModal(false)
                        setprofileUpdateSuccessModal(false)
                    }
                } else {
                    setErrorMessage(data.message);
                }
            } catch (error) {
                setErrorMessage(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchFarmerDetails();
    }, [storedMblNumber]);


    //for profile Update
    const onSubmit = async (e) => {
        let errors = {};
        if (!totalAcres) {
            errors = { ...errors, totalAcres: true };
        } else {
            errors = { ...errors, totalAcres: false };
        }

        if (!selectedCrop) {
            errors = { ...errors, cropName: true };
        } else {
            errors = { ...errors, cropName: false };
        }
        setFormErrors(errors);
        if (!errors.totalAcres && !errors.cropName) {
            setLoading(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL_GLOBAL}updateFarmerProfileWeb`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        mobileNumber: formData.mobileNumber,
                        firstName: formData.name,
                        lastName: formData.lastName,
                        emailId: "",
                        riceCropAcres: "",
                        groundNutCropAcres: selectedCrop === "Ground_Nut" ? totalAcres : "",
                        soyabeanCropAcres: selectedCrop === "Soyabean" ? totalAcres : "",
                        districtName: formData.districtName,
                        // villageName: formData.village,
                        villageName:"",
                        type: "updateProfile",
                        shareType: "",
                    }),
                });

                const result = await response.json();
                if (result.statusCode === "200") {
                    console.log(result.response);
                    const parsedResponse = JSON.parse(result.response);
                    const resshareProductInfo = parsedResponse.shareProductInfo;
                    const resprofileUpdate = parsedResponse.profileUpdate;
                    sessionStorage.setItem("resshareProductInfo", resshareProductInfo);
                    sessionStorage.setItem("resprofileUpdate", resprofileUpdate);
                    setprofileUpdateModal(false);
                    if (resshareProductInfo && resprofileUpdate) {
                        setsharesuccessModal(true);
                    } else {
                        setprofileUpdateSuccessModal(true);
                    }
                } else {
                    alert(result.message);
                    setErrorMessage(result.message);
                }
            } catch (error) {
                setErrorMessage(error.message);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleRewards = () => {
        navigate(`/${lang}/rewardjourney?m=${encodeURIComponent(btoa(storedMblNumber))}`);
    };

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
          .modal-backdrop {
            background-color: #000 !important;
          }
          .modal-backdrop.show {
            opacity: 0.7 !important;
          }
            .modal-content {
                border-radius: 10px !important;
                }
        `;
        document.head.appendChild(style);
        return () => {
            document.body.style.backgroundColor = '';
            document.head.removeChild(style);
        };
    }, []);

    return (
        <>
            <Header />
            <div className="main px-2">
                <div className="container p-0">
                    {loading && <Loader />}
                    <div className="card border-0">
                        <div className="card-header p-0 border-0 bg-transparent"
                        >
                            <img
                                src={bannerImageSrc}
                                className="img-fluid w-100"
                                alt="banner"
                            />
                        </div>
                        <div className="card-body px-0 pb-2 pt-0 pb-2">
                            {/* <h4 className="text-center" id="headingText">{t('Strongarm_Survey')}</h4> */}
                            <img src={textBannerImageSrc} alt="textBanner" className="img-fluid mt-3" />

                            {/* <img src={ThankyouImg} alt="thankyouImg" className="thankyouImg"></img> */}

                            {/* <p className="text-center mt-2 mb-2" style={{ color: "#0974BA", fontSize: "15px", letterSpacing: '0.4px' }}>
                                <b>{t("thanks_text")}</b></p> */}

                            {/* <p className="text-center" style={{ fontSize: "14px", color: "#000000" }}>
                                {t("eligible_text")}</p> */}

                            {/* <h6 className="detailsHeading">{t("SelectSteps")}</h6> */}

                            <div className="homeContent mt-4">
                                <div className="card p-0 align-items-center text-center stepsCard"
                                    onClick={() => {
                                        ReactGA.event({
                                            category: 'User Home Rewards',
                                            action: 'CLK_HOME_REWARD_BTN',
                                        });
                                        if (stepOneClear) {
                                            return;
                                        }
                                        setprofileUpdateModal(true);
                                    }}>

                                    {stepOneClear && (<div className="overlay">
                                        <img src={greenRight} alt="greenRight"
                                            className="stepOne-UpdatedForm"
                                        />

                                    </div>)}

                                    <div className="card-body p-0 cardsec">
                                        <img src={FarmingDetails} alt="FarmingDetails" className="img-fluid" />
                                        <div className="serialSymbol">{t("Step_1")}</div>
                                        <p className="cardTitle">{t("UpdateFarmingDetails")}</p>
                                        {/* <img
                                            src={updateProfileImage}
                                            className="homeImage img-fluid stepOne-img"
                                            alt="updateProfileImage"
                                        />
                                        <img src={oneSymbol} alt="oneSymbol" className="serialSymbol" />
                                        <div className="serialSymbol">{t('Step_1')}</div>
                                        <p className="mt-3 cardTitle">{t("UpdateFarmingDetails")}</p> */}
                                    </div>
                                </div>

                                <div
                                    className="card text-black text-decoration-none p-0 align-items-center text-center stepsCard"
                                    onClick={() => {
                                        if (stepTwoClear) {
                                            return;
                                        }
                                        window.location.href = `${process.env.REACT_APP_API_URL_PRODUCT}${t("language")}?mobileNumber=${btoa(storedMblNumber)}`;
                                    }}
                                >

                                    {stepTwoClear && (<div className="overlay">
                                        <img src={greenRight} alt="greenRight"
                                            className="stepTwo-ViewProduct"
                                        />
                                    </div>)}

                                    <div className="card-body p-0 cardsec">
                                        <img src={productShare} alt="productShare" className="img-fluid" />
                                        <div className="serialSymbol">{t("Step_2")}</div>
                                        <p className="cardTitle">{t("ViewProductInfo")}</p>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="text-center my-4" style={{ fontSize: "15px" }}>
                            {lang === 'en' && (<span>{t("visit")}</span>)} {" "}
                            <a className="text-black"
                                href={`${process.env.REACT_APP_API_URL_TC}${t("language")}`}>
                                <span className="text-decoration-underline text-primary">{t("termsAndConditions")}</span></a> {" "}
                            {lang !== 'en' && (<span>{t("visit")}</span>)}
                        </div>

                        {/* //profileUpdateModal */}
                        <CustomModal
                            id={"profileUpdateModal"}
                            title={""}
                            content={
                                <>
                                    <div className="mt-3">
                                        <button
                                            type="button"
                                            className="close"
                                            aria-label="Close"
                                            onClick={handleCloseModal}>
                                            <img src={Close} alt="Close"
                                                className="button-Close"
                                            />
                                        </button>
                                        <p className="modal_heading mb-1">{t('Update_Farming')}</p>
                                        <hr className="mt-2"></hr>
                                    </div>

                                    <h6 className="detailsHeading text-left mb-0">{t('Select_Crop')}</h6>

                                    <form onSubmit={handleSubmit(onSubmit)}>

                                        <div className="form-group mt-3 mb-4" >
                                            <div className=" d-flex align-items-center cropSec">

                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio"
                                                        name="cropName" value="soyabean" id="Soyabean" onChange={handleCropChange} />
                                                    <label className="form-check-label cropName mb-0" htmlFor="Soyabean">
                                                        {t('Soyabean')}
                                                    </label>
                                                </div>

                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio"
                                                        name="cropName" value="ground nut" id="Ground_Nut" onChange={handleCropChange} />
                                                    <label className="form-check-label cropName  mb-0" htmlFor="Ground_Nut">
                                                        {t('Ground_Nut')}
                                                    </label>
                                                </div>
                                            </div>
                                            {formErrors.cropName && <div className="text-danger text-left">{t("cropErrorMsg")}</div>}
                                        </div>

                                        <div className="form-group text-left">
                                            <label htmlFor="totalAcres" className="labelText cropLabel">{t('Total_acres_this_Season')}</label>
                                            <input type="text" className={`form-control acresInput totalacres-styles shadow  mb-1 ${errors.totalAcres ? "is-invalid" : ""
                                                }`}
                                                placeholder={t('Total_acres')}
                                                name="totalAcres"
                                                id="totalAcres"
                                                autoComplete="off"
                                                onChange={handletotalAcresInputChange}
                                            />
                                            {formErrors.totalAcres && <div className="text-danger">{t("total_acresErrorMsg")}</div>}
                                        </div>
                                        <button
                                            type="submit"
                                            className={`btn submitBtn text-center btn-secondary w-100 updateButton center-textbtn mt-3 text-white`}
                                            id="submitBtn">
                                            {t('Update')}
                                        </button>
                                    </form>
                                </>
                            }
                            footer={""}
                            show={profileUpdateModal}
                            onHide={() => setprofileUpdateModal(false)}
                        />

                        {/* update sucess modal */}
                        <CustomModal
                            id={"profileUpdateSuccessModal"}
                            title={""}
                            content={
                                <>
                                    <div className="mt-3">
                                        <button
                                            type="button"
                                            className="close"
                                            aria-label="Close"
                                            onClick={(e) => {
                                                e.preventDefault(); // ✅
                                                setprofileUpdateSuccessModal(false);
                                                const getprofileUpdate = sessionStorage.getItem("resprofileUpdate") || queryprofileUpdate; 
                                                const url = new URL(window.location.href);
                                                const params = new URLSearchParams(url.search);
                                                if (params.get('profileUpdate') === 'false') {
                                                    params.set('profileUpdate', getprofileUpdate);
                                                    window.history.replaceState({}, '', `${url.pathname}?${params}`);
                                                }
                                                setStepOneClear(getprofileUpdate)
                                            }}
                                        >
                                            <img src={Close} alt="Close"
                                                className="button-Close"
                                            />
                                        </button>
                                    </div>
                                    <img src={greenRight} alt="green_right" className="greenRight" />

                                    <p className="my-4 clickOn-Ok">
                                        {t('Farming_details_update')}<br></br>
                                        {/* <span className="subText">{t('step_2_click')}</span> */}

                                    </p>

                                    <button className={`btn submitBtn text-center btn-secondary w-100 updateButton center-textbtn mt-3 text-white`}
                                        id="submitBtn" onClick={handleStepOneClear}>
                                        {t('go_step2')}
                                    </button>
                                </>
                            }
                            footer={""}
                            show={profileUpdateSuccessModal}
                            onHide={() => setprofileUpdateSuccessModal(false)}
                        />

                        <CustomModal
                            id={"getRewardsModal"}
                            title={""}
                            content={
                                <>
                                    <div className="mt-3">
                                        <button
                                            type="button"
                                            className="close"
                                            aria-label="Close"
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                        >
                                            <img src={Close} alt="Close"
                                                className="button-Close"
                                            />
                                        </button>
                                    </div>
                                    <img src={greenRight} alt="green_right" className="greenRight" />

                                    <p className="my-4 clickOn-Ok">{t('Click_ok')}</p>

                                    <button className={`btn submitBtn text-center btn-secondary w-100 updateButton center-textbtn mt-3 text-white`}
                                        id="submitBtn" onClick={handleRewards}>
                                        {t('Ok')}
                                    </button>
                                </>
                            }
                            footer={""}
                            show={rewardsModal}
                            onHide={() => setRewardsModal(false)}
                        />

                        <CustomModal
                            id={"sharesuccessModal"}
                            title={""}
                            giftImages={true}
                            content={
                                <>
                                    <div className="mt-3">
                                        <button
                                            type="button"
                                            className="close"
                                            aria-label="Close"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleRewards()
                                            }}
                                        >
                                            <img src={Close} alt="Close"
                                                className="button-Close"
                                            />
                                        </button>
                                    </div>
                                    {/* <img src={greenRight} alt="green_right" className="greenRight" /> */}

                                    <div class="congratsText">{t('Congratulations')}</div>
                                    <div className="mt-2">
                                        <p className="text-center mb-4">{t('all_set')} </p>
                                        {/* <p className="text-center mb-2" style={{ color: '#5D5D5D', fontSize: '15px' }}>
                                            You’ve successfully completed all the mandatory
                                            steps for the Strongarm Reward Program.
                                        </p>
                                        <p className="text-center mb-2" style={{ color: '#5D5D5D', fontSize: '15px' }}>
                                            Now, buy and scan the product to unlock exciting gifts!
                                        </p> */}
                                    </div>
                                    <div className="footerBtns" onClick={handleRewards} >
                                        <div
                                            className="btn btn-secondary btn-rounded closBtn w-100 footerbtns-handle"
                                        >
                                            {t('Next')}
                                        </div>
                                    </div>
                                </>
                            }
                            footer={""}
                            show={sharesuccessModal}
                            onHide={() => setsharesuccessModal(false)}
                        />

                    </div>
                </div>
            </div>
        </>
    );
};

export default Congratulations;
